import {invalidateQueries, q} from "../state";
import {AiPromptKind, AiPromptInfo, PromptCategoryInfo} from "platformed-client/types";
import {platformedClient} from ".";

export async function listCategories(): Promise<PromptCategoryInfo[]> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/custom_prompt_categories", {});
}

export async function list(): Promise<AiPromptInfo[]> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/custom_prompts", {});
}

export async function update(prompt: AiPromptKind, templateText: string): Promise<AiPromptInfo> {
  const res = await platformedClient.internalRequest("put", "/region/{region}/api/custom_prompts/{prompt}", {
    path: {prompt},
    body: {template_text: templateText},
  });
  await invalidateQueries([q.customPrompts.filter()]);
  return res;
}

export async function resetAll(): Promise<void> {
  await platformedClient.internalRequest("delete", "/region/{region}/api/custom_prompts", {});
  await invalidateQueries([q.customPrompts.filter()]);
}

export async function reset(prompt: AiPromptKind): Promise<AiPromptInfo> {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/custom_prompts/{prompt}", {
    path: {prompt},
  });
  await invalidateQueries([q.customPrompts.filter()]);
  return res;
}
